import { render, staticRenderFns } from "./TaxRates.vue?vue&type=template&id=3258a8c6&"
import script from "./TaxRates.vue?vue&type=script&lang=ts&"
export * from "./TaxRates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports